import React from 'react';

import Radium from 'radium';
import AppUtil from 'AppUtil';


import ReactTooltip from 'react-tooltip';

import SalesTargetForm from 'views/designer/SalesTargetForm';

const style = {
	rowContainer: {display: 'flex', flexDirection: 'row', flexWrap: 'wrap', 
					border:'1px solid #eee', background: 'white'},

	rowBox: {margin: "10px", cursor: 'pointer', flexGrow: '1', borderRight: '2px solid #eee', 
				textAlign: 'center', display: 'flex', flexDirection: 'column',
				padding: '10px',
				'@media (max-width: 700px)': {padding: '0 5px', borderRight: 'none'}
			}
}


const EachBox = Radium((props) => {

	const title = props.title;
	const value = props.value;

	let boxStyle = [style.rowBox];

	if(props.style)
		boxStyle.push(props.style);

	const toolTip = props.toolTip;
	return <span style={boxStyle}>
		<span style={{margin: '5px', color: '#999', fontSize: '120%'}} data-tip data-for={props.toolTipId}>{title}</span>
		<span style={{margin: '0px', color: '#555', fontSize: '125%'}}>{value}</span>

		{
			toolTip &&
			<ReactTooltip id={props.toolTipId} place="top" type="info" 
							effect="solid" className='productStatToolTip'>
				<span>{toolTip}</span>
			</ReactTooltip>	
		}
		
	</span>
});

class TargetAchieved extends React.Component {


	render() {
		const product = this.props.product;
		const currentTarget = this.props.currentTarget;

		return <div style={{fontWeight: 'bold', textAlign: 'center', margin: '0 0 20px 0', padding: '10px', border: '1px solid #c1bebe'}}>
				<h3 style={{margin: '10px 0'}}>{"CONGRATULATION! You've unlocked the earned amount."}</h3>

				<SalesTargetForm product={product} currentTarget={currentTarget} 
								style={{width: '50%', margin: '0 auto', '@media (max-width: 770px)': {width: '100%'}}}/>
			</div>
	}
}

class ProductStat extends React.Component {

	calculateCommission(currentTarget, margin) {
		return (currentTarget.commissionPct * margin/100.0) || 0;
	}

	getCommissionStr(stat) {
		const currentTarget = stat.currentTarget;
		const product = stat.product;

		if(stat.marginRange) {
			const margins = stat.marginRange.split("-");
			const minCommission = this.calculateCommission(currentTarget, margins[0]);
			// const maxCommission = this.calculateCommission(currentTarget, margins[1]);
			return AppUtil.formatNumber(minCommission) + "+";
		}
			

		return AppUtil.formatNumber(this.calculateCommission(currentTarget, product.margin));
	}

	render() {
		const stat = this.props.stat;
		const product = this.props.product;

		if(!stat || !product)
			return null;

		const currentTarget = stat.currentTarget;

		if(!currentTarget)
			return null;
		
		const targetAchieved = stat.targetAchieved >= currentTarget.salesTarget;

		const amountEarned = stat.amountEarned;

		let amountEarnedTitle = <span>Amount Earned</span>;
		let amountEarnedToolTip = null;
		const showTargetOption = currentTarget.salesTarget > 1;

		if(targetAchieved) {
			amountEarnedTitle = <span><i className="fa fa-unlock" aria-hidden="true" style={{color: '#31ad31'}}></i> Amount Earned</span>;
			amountEarnedToolTip = showTargetOption? "Amount has been unlocked. You have completed the target.": null;
		} else {
			amountEarnedTitle = <span><i className="fa fa-lock" aria-hidden="true"></i> Amount Earned</span>;
			amountEarnedToolTip = showTargetOption? "Amount is locked and cannot be withdrawn.": null;
		}

		const hasPendingOrders = stat.pendingOrdersCount > 0;

		const pendingTitle = <span>
								<i style={hasPendingOrders? {color: '#31ad31'}: {}} 
								className="fa fa-truck" aria-hidden="true"></i> Pending Orders
							</span>;

		return <div className='flexColumn' style={{margin: "20px auto"}} id="productStat">
					
					{
						showTargetOption && !targetAchieved &&
						<div className='flexRow' 
								style={{fontSize: '130%', justifyContent: 'space-evenly', color: '#555', width: '50%',
										margin:'0 auto 10px auto', '@media (max-width: 770px)': {width: '100%'}
									}}>
							<span style={{marginRight: '15px'}}><b>Target: </b>{currentTarget.salesTarget}</span>
							<span><b>Remaining: </b>{currentTarget.salesTarget - stat.targetAchieved}</span>
						</div>
					}

					{
						showTargetOption && targetAchieved &&
						<TargetAchieved product={product} currentTarget={currentTarget} />
					}
						
					
					
					<div style={style.rowContainer}>
						<EachBox title={pendingTitle} value={stat.pendingOrdersCount || 0} />

						<EachBox title='Fulfilled Orders' value={stat.targetAchieved || 0} />

						<EachBox title='Commission' value={"Rs. "+ this.getCommissionStr(stat)} 
								toolTipId="commissionToolTip" toolTip="This is the amount you can earn per quantity sold." />

						<EachBox title={amountEarnedTitle} value={"Rs. "+AppUtil.formatNumber(amountEarned)} style={{borderRight: 'none'}} 
							toolTipId="amountEarnedToolTip" toolTip={amountEarnedToolTip} />
					</div>
			</div>
	}
}

export default Radium(ProductStat);




// WEBPACK FOOTER //
// ./src/views/product/ProductStat.js